class LoaderComponent {
	container

	setContainer(container) {
		this.container = container
		this.render()
		return this
	}

	render() {
		const loader = this.getElement()
		this.container.appendChild(loader)
	}

	getElement() {
		const div = document.createElement('div')
		div.innerHTML = this.getHtml()
		return div.firstElementChild
	}
	getHtml() {
		return `
			<div class="loader">
			<p>Trwa ładowanie produktów</p>
				<svg class="svg-loader" xmlns="http://www.w3.org/2000/svg" width="46.354" height="44.247" viewBox="0 0 46.354 44.247">
					<g id="loading" transform="translate(0 -11.636)">
						<path id="Path_261" data-name="Path 261" d="M10.535,221.091H2.107a2.107,2.107,0,1,0,0,4.214h8.428a2.107,2.107,0,1,0,0-4.214Z" transform="translate(0 -190.492)" fill="#0C57A6"/>
						<path id="Path_262" data-name="Path 262" d="M382.9,221.091H374.47a2.107,2.107,0,1,0,0,4.214H382.9a2.107,2.107,0,0,0,0-4.214Z" transform="translate(-338.651 -190.492)" fill="#0C57A6" opacity="0.4"/>
						<path id="Path_263" data-name="Path 263" d="M74.74,320.446l-5.96,5.96a2.107,2.107,0,0,0,2.98,2.98l5.96-5.96a2.107,2.107,0,0,0-2.98-2.98Z" transform="translate(-61.992 -280.29)" fill="#0C57A6" opacity="0.9"/>
							<g id="Group_1563" data-name="Group 1563" transform="translate(21.07 11.636)">
								<path id="Path_264" data-name="Path 264" d="M234.834,11.636a2.107,2.107,0,0,0-2.107,2.107v4.214a2.107,2.107,0,0,0,4.214,0V13.743A2.107,2.107,0,0,0,234.834,11.636Z" transform="translate(-232.727 -11.636)" fill="#0C57A6" opacity="0.1"/>
								<path id="Path_265" data-name="Path 265" d="M338.04,57.144l-5.96,5.96a2.107,2.107,0,1,0,2.98,2.98l5.96-5.96a2.107,2.107,0,0,0-2.98-2.98Z" transform="translate(-322.524 -52.463)" fill="#0C57A6" opacity="0.2"/>
							</g>
						<path id="Path_266" data-name="Path 266" d="M234.834,360.727a2.107,2.107,0,0,0-2.107,2.107v8.428a2.107,2.107,0,0,0,4.214,0v-8.428A2.107,2.107,0,0,0,234.834,360.727Z" transform="translate(-211.657 -317.486)" fill="#0C57A6" opacity="0.8"/>
						<path id="Path_267" data-name="Path 267" d="M335.06,320.445a2.107,2.107,0,1,0-2.98,2.98l5.96,5.96a2.107,2.107,0,0,0,2.98-2.98Z" transform="translate(-301.454 -280.29)" fill="#0C57A6" opacity="0.6"/>
					</g>
				</svg>
			</div>
		`
	}

	handler(status) {
		const action = status === 'IN_PROGRESS' ? 'remove' : 'add'
		this.container.classList[action]('d-none')
	}
}

const loaderComponent = new LoaderComponent()
export {
	LoaderComponent,
	loaderComponent
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/com_catalog_search_async/components/LoaderComponent.js